import {
  ControlFilter,
  ConversationFilterIds
} from 'modules/conversations/constants/enums';
import { getConversationFilterLabel } from '../utils/getConversationFilterLabel';

export const controlFilterOptions = [
  {
    value: ControlFilter.AI,
    label: getConversationFilterLabel(
      ConversationFilterIds.control,
      ControlFilter.AI
    )
  },
  {
    value: ControlFilter.MANUAL,
    label: getConversationFilterLabel(
      ConversationFilterIds.control,
      ControlFilter.MANUAL
    )
  }
];
